export const isDevMode = import.meta.env.VITE_DEV_MODE === "1" || false;

export const wordPressLink = (path: string) => {
  return `${import.meta.env.VITE_JMACX_WORDPRESS_URL}/${path}`;
};

export const formatter = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
});
